export default __webpack_public_path__ + "static/media/7.2a2102f4.jpg";